import { z } from 'zod';

import { TaskPrioritySchema } from './task-priority';
import { TaskStatusSchema } from './task-status';

export const TaskSchema = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string(),
  dueDate: z.date().optional(),
  status: TaskStatusSchema,
  priority: TaskPrioritySchema,
  assignee: z.string().optional(),
});

export type Task = z.infer<typeof TaskSchema>;
